module.exports = __webpack_public_path__ + "static/img/hs-wdj.c4fa859a.png";